import React from "react";

export const FormLabelStyle = ({  label, impField }) => {
  return (
    impField ? (<>{label}<span style={{ color: "red", content: "*", marginLeft: "2px" }}>*</span></>) : (<div >{label}</div>)
  )
}